import { render, staticRenderFns } from "./AppMyMenu.vue?vue&type=template&id=2cb98a14&scoped=true"
import script from "./AppMyMenu.vue?vue&type=script&lang=js"
export * from "./AppMyMenu.vue?vue&type=script&lang=js"
import style0 from "./AppMyMenu.vue?vue&type=style&index=0&id=2cb98a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb98a14",
  null
  
)

export default component.exports